import { getJwtString } from '@backoffice-frontend/authentication'
import { ENV, Environment } from '@backoffice-frontend/environment'
import cube from '@cubejs-client/core'
import { CubeProvider as Provider } from '@cubejs-client/react'
import type { ReactNode } from 'react'

// API endpoints
const backofficeDataApiEndpoints: Record<Environment, string> = {
  [Environment.local]: 'http://localhost:4000/cubejs-api/v1',
  [Environment.test]: '',
  [Environment.development]:
    'https://backoffice-data-api.insights.dev.moia-group.io/cubejs-api/v1',
  [Environment.integration]:
    'https://backoffice-data-api.insights.int.moia-group.io/cubejs-api/v1',
  [Environment.production]:
    'https://backoffice-data-api.insights.prd.moia-group.io/cubejs-api/v1',
  [Environment['production.us-east-1']]:
    'https://backoffice-data-api.insights.prd.moia-group.io/cubejs-api/v1',
}
const backofficeMultitenantDataApiEndpoints: Record<Environment, string> = {
  [Environment.local]: 'http://localhost:4000/multi-tenant-api/v1',
  [Environment.test]: '',
  [Environment.development]:
    'https://multi-tenant-cube-data-api.insights.dev.moia-group.io/multi-tenant-api/v1',
  [Environment.integration]:
    'https://multi-tenant-cube-data-api.insights.int.moia-group.io/multi-tenant-api/v1',
  [Environment.production]:
    'https://multi-tenant-cube-data-api.insights.prd.moia-group.io/multi-tenant-api/v1',
  [Environment['production.us-east-1']]:
    'https://multi-tenant-cube-data-api.insights.prd.moia-group.io/multi-tenant-api/v1',
}

const getToken = async () => {
  const token = await getJwtString()
  return token ?? ''
}

// Create the cube API instances
const regularCubeApi = cube(getToken, {
  apiUrl: backofficeDataApiEndpoints[ENV],
})
const multitenantCubeApi = cube(getToken, {
  apiUrl: backofficeMultitenantDataApiEndpoints[ENV],
})

// Simple provider that allows switching between APIs
export const CubeProvider = ({
  children,
  useMultitenantCubeApi = false,
}: {
  children: ReactNode
  useMultitenantCubeApi?: boolean
}) => {
  return (
    <Provider
      cubeApi={useMultitenantCubeApi ? multitenantCubeApi : regularCubeApi}
    >
      {children}
    </Provider>
  )
}
